﻿"use strict";

angular.module('app.financeiro').factory('baixaAutomaticaFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {
    var _apiName = 'RetornoBanco';

    var _listBaixaAutomaticaDetalhes = function (codigo, options, search) {
        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        dto.parms.push({ "name": "Search", "value": search });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListBaixaAutomaticaDetalhes', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listBaixaTituloAutomaticaResumo = function (codigo) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListBaixaTituloAutomaticaResumo', dto);
    };

    var _reprocessarBaixaAutomatica = function (codigo) {
        var dto = {};
        dto.id = codigo;

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ReprocessarBaixaAutomatica', dto);
    };

    var _aprovarArquivoBaixaAutomatica = function (aprovar, codigo) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        dto.parms.push({ "name": "Aprovar", "value": aprovar });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AprovarArquivoBaixaAutomatica', dto);
    }

    var _listBaixaAutomatica = function (search, options, dataInicio, dataTermino, situacao, numeroProposta) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": situacao });
        dto.parms.push({ "name": "NumeroProposta", "value": numeroProposta });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListBaixaAutomatica', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var factory = {};

    factory.listBaixaAutomatica = _listBaixaAutomatica;
    factory.listBaixaAutomaticaDetalhes = _listBaixaAutomaticaDetalhes;
    factory.listBaixaTituloAutomaticaResumo = _listBaixaTituloAutomaticaResumo;
    factory.reprocessarBaixaAutomatica = _reprocessarBaixaAutomatica;
    factory.aprovarArquivoBaixaAutomatica = _aprovarArquivoBaixaAutomatica;

    return factory;
}])
